<template>
  <v-dialog v-model="active" fullscreen full-width>
    <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
      <v-layout justify-center align-center>
        <v-progress-circular
          :size="75"
          color="primary"
          indeterminate
        />
      </v-layout>
    </v-container>
  </v-dialog>
</template>

<script>
  export default {
    name: 'Loading',
    props: {
      active: Boolean,
      loading: {
        type: Object,
        default: () => ({})
      }
    },
  }
</script>